import { AccountInfo, PublicClientApplication } from '@azure/msal-browser';
import { environment } from '../../../environments/environment';

export const authConfig = {
  auth: {
    clientId: environment.clientId,
    authority: `https://login.microsoftonline.com/${environment.tenantId}`,
  },
};

const data = {
  account: null as AccountInfo | null,
  msalInstance: new PublicClientApplication(authConfig),
  token: '',
};

export function useAuth() {
  return data;
}
